var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvioOBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.12,
    height: 75.043,
    viewBox: "0 0 79.12 75.043",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#353841;}.b{fill:#2fffd1;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M940.7,261.525v.114a8.158,8.158,0,0,0,2.62,5.9,24.466,24.466,0,0,1,7.373,17.846v.281c0,12.788-8.713,23.469-22.486,23.469-13.21,0-22.625-10.822-22.625-23.75V285.1a24.231,24.231,0,0,1,7.362-17.964,7.958,7.958,0,0,0,2.629-5.819h0a7.765,7.765,0,0,0-12.651-6.025,38.409,38.409,0,0,0-14.345,30.088v.281c0,21.08,16.724,38.366,39.349,38.366,22.907,0,39.771-17.567,39.771-38.647V285.1a38.006,38.006,0,0,0-14.075-29.772A7.946,7.946,0,0,0,940.7,261.525Z",
    transform: "translate(-888.573 -248.984)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1016.17,242.727a7.219,7.219,0,1,1,7.219,7.218,7.218,7.218,0,0,1-7.219-7.218",
    transform: "translate(-983.857 -235.509)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvioOBlack);
export default __webpack_public_path__ + "static/media/evio_o_black.3b419c58bccc420bb5153370c8ae3b4c.svg";
export { ForwardRef as ReactComponent };